(() => {
  const root = document.querySelector('[data-bnb-winter-snow]');
  if (!root) return;
  const canvas = root.querySelector('canvas');
  const button = root.querySelector('button');
  const label = button.querySelector('[data-snow-label]');
  const ctx = canvas.getContext('2d');
  if (!ctx) return;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const preferenceKey = 'bnb-winter-snow-paused';
  let paused = true;
  try {
    paused = localStorage.getItem(preferenceKey) !== 'false';
  } catch {
    try { paused = sessionStorage.getItem(preferenceKey) !== 'false'; } catch {}
  }
  let width = 0, height = 0, flakes = [], frame = 0, last = 0;
  const resize = () => {
    width = document.documentElement.clientWidth;
    height = window.innerHeight;
    const ratio = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = width * ratio;
    canvas.height = height * ratio;
    canvas.style.width = width + 'px';
    canvas.style.height = height + 'px';
    ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
    flakes = Array.from({ length: width < 750 ? 26 : 44 }, (_, i) => ({
      x: Math.random() * width, y: Math.random() * height,
      size: 1.5 + Math.random() * 3, speed: 17 + Math.random() * 24,
      phase: Math.random() * Math.PI * 2, crystal: i % 3 === 0
    }));
  };
  const draw = time => {
    if (paused || reduced.matches || document.hidden) { frame = 0; return; }
    const delta = last ? Math.min((time - last) / 1000, .05) : .016;
    last = time;
    ctx.clearRect(0, 0, width, height);
    for (const flake of flakes) {
      flake.y += flake.speed * delta;
      flake.x += Math.sin(time / 3000 + flake.phase) * 7 * delta;
      if (flake.y > height + 12) { flake.y = -12; flake.x = Math.random() * width; }
      ctx.save(); ctx.translate(flake.x, flake.y);
      if (flake.crystal) {
        ctx.strokeStyle = 'rgba(65,108,158,.62)'; ctx.lineWidth = 1;
        for (let arm = 0; arm < 6; arm++) {
          ctx.rotate(Math.PI / 3); ctx.beginPath(); ctx.moveTo(0, 0);
          ctx.lineTo(0, flake.size * 2); ctx.moveTo(0, flake.size);
          ctx.lineTo(-2, flake.size * 1.6); ctx.moveTo(0, flake.size);
          ctx.lineTo(2, flake.size * 1.6); ctx.stroke();
        }
      } else {
        ctx.shadowColor = 'rgba(42,100,128,.35)'; ctx.shadowBlur = 3;
        ctx.fillStyle = 'rgba(255,255,255,.8)'; ctx.beginPath();
        ctx.arc(0, 0, flake.size, 0, Math.PI * 2); ctx.fill();
      }
      ctx.restore();
    }
    frame = requestAnimationFrame(draw);
  };
  const sync = () => {
    if (frame) cancelAnimationFrame(frame);
    frame = 0; last = 0;
    const stopped = paused || reduced.matches;
    button.hidden = reduced.matches;
    button.setAttribute('aria-pressed', String(stopped));
    label.textContent = stopped ? button.dataset.resumeLabel : button.dataset.pauseLabel;
    ctx.clearRect(0, 0, width, height);
    if (!stopped && !document.hidden) frame = requestAnimationFrame(draw);
  };
  button.addEventListener('click', () => {
    paused = !paused;
    try {
      localStorage.setItem(preferenceKey, String(paused));
    } catch {
      try { sessionStorage.setItem(preferenceKey, String(paused)); } catch {}
    }
    sync();
  });
  window.addEventListener('resize', () => { resize(); sync(); }, { passive: true });
  document.addEventListener('visibilitychange', sync);
  reduced.addEventListener('change', sync);
  resize(); sync();
})();

